import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

import useTable from "../components/useTable2.js";

import { Mensaje } from "../components/mensajes";
import axios from "axios";
import { Dimmer } from "../components/spinner.jsx";
import { DangerButton, SuccessButton } from "../ui/buttons/Button.jsx";

const CatalogoCatProgramatica = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      label: "CATEGORIA PROGRAMATICA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: 'white',
    },
    {
      label: "DESCRIPCIÓN",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: 'white',
    },
    {
      label: "CÓDIGO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: 'white',
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idcategoriaprogramatica.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.categoriaprogramatica
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    setActivate(true);

    let campos =
      "categoriaprogramatica, trim(descripcion)  AS descripcion, idcategoriaprogramatica";
    let nomtab = "categoriaprogramatica";
    let nomid = "idefiscal";
    let condic = "substr(categoriaprogramatica,7,10) != '0000'";

    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var datos = [];
          for (let i = 0; i < response.data.length; i++) {
            datos.push({
              idcategoriaprogramatica: response.data[i].idcategoriaprogramatica,
              descripcion: response.data[i].descripcion,
              categoriaprogramatica: response.data[i].categoriaprogramatica,
            });
          }
          setRecords(datos);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarCatProgramatica = () => {
    var idcategoriaprogramatica = values[0].idcategoriaprogramatica;
    var descripcion = values[0].descripcion;
    var categoriaprogramatica = values[0].categoriaprogramatica;

    blanquear();
    props.onHideAceptaCatProgramatica(
      idcategoriaprogramatica,
      descripcion,
      categoriaprogramatica
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setActivo(false);

    var idcategoriaprogramatica =
      recordsAfterPagingAndSorting()[index].idcategoriaprogramatica;
    var descripcion = recordsAfterPagingAndSorting()[index].descripcion;
    var categoriaprogramatica =
      recordsAfterPagingAndSorting()[index].categoriaprogramatica;

    var datos = [];
    datos.push({
      idcategoriaprogramatica,
      descripcion,
      categoriaprogramatica,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Categorias Programaticas</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12 m-0">
          <div className="input-group input-group-sm mb-3 m-0 col-md-5">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill"
            />
          </div>
        </div>
        <div className="col-md-12 " style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td className="py-2 text-center" style={{ width: "100px" }}>
                      {item.categoriaprogramatica}
                    </td>
                    <td className="py-2 text-start" style={{ width: "250px" }}>
                      {item.descripcion}
                    </td>
                    <td className="py-2 text-center" style={{ width: "50px" }}>
                      {item.idcategoriaprogramatica}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton disabled={activo} onClick={seleccionarCatProgramatica}>
          Aceptar
        </SuccessButton>
       <DangerButton onClick={cancelar}>
          Cancelar
       </DangerButton>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoCatProgramatica;
